import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class CustomFieldID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
